import { render } from "./chat-with-service.vue?vue&type=template&id=5d0194c2"
import script from "./chat-with-service.vue?vue&type=script&lang=js"
export * from "./chat-with-service.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__